import {
  ConciergeCatalogPage,
  ConciergeItemCatalog,
  ConciergeLocale,
  resolveCatalogListingRobots,
} from '@/lib/entities/concierge';
import { PageSeo } from '@/lib/entities/seo';
import { SeoEntries } from '@/lib/entities/seo/lib/seo-entries';

import { useRouter } from 'next/router';

import { ConciergeCatalogPageView } from './ConciergePages';

type ConciergeCatalogRouteProps = {
  page: ConciergeCatalogPage;
  locale: ConciergeLocale;
  pageSeo: PageSeo | null;
  listingRobots: string | null;
  path: `/${string}`;
  keywords: string;
  itemCatalog?: ConciergeItemCatalog;
};

export const ConciergeCatalogRoute = ({
  page,
  locale,
  pageSeo,
  listingRobots,
  path,
  keywords,
  itemCatalog,
}: ConciergeCatalogRouteProps) => {
  const router = useRouter();

  return (
    <>
      <SeoEntries
        fallback={{
          title: page.metaTitle,
          description: page.metaDescription,
          keywords,
          openGraphImage: '/images/og.png',
        }}
        seo={pageSeo}
        language={locale}
        path={path}
        robots={resolveCatalogListingRobots(
          router.query.page,
          listingRobots,
          router.isReady
        )}
      />
      <ConciergeCatalogPageView
        page={page}
        locale={locale}
        h1={pageSeo?.h1}
        itemCatalog={itemCatalog}
      />
    </>
  );
};
